import { useState } from "react";

import { DataGroupEditForm } from "src/app/features/DataGroup/components/forms/DataGroupEditForm";
import { ActionBar } from "../../../../components/ActionBar/ActionBar";
import { PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { FPage, FPageContent, FPageHeader } from "../../../../components/AppLayout/components/FPageLayout";
import { BackButton } from "../../../../components/FeatureButtons/BackButton";
import { SubmitButton } from "../../../../components/FeatureButtons/SubmitButton";
import { canAccess } from "../../../../core/router/auth/permissions";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import { BASE_PATH } from "../../../../core/router/types/routerTypes";

export const DataGroupEditFormPage = () => {
    const [runSubmit, setRunSubmit] = useState(0);
    const [hasAccessError, setHasAccessError] = useState(false);
    const hasWriteAccess = canAccess(ResourceName.DATA_GROUPS, "basicTabsWrite");

    const triggerFormSubmit = () => setRunSubmit(runSubmit + 1);

    return (
        <FPage>
            <FPageHeader>
                <PageTitle translationKey="page.title.dataGroupsEditFormPage" />
                <ActionBar>
                    <SubmitButton isDisabled={hasAccessError || !hasWriteAccess} onClick={triggerFormSubmit} />
                    <BackButton isDisabled={false} url={`${BASE_PATH}/${ResourceName.DATA_GROUPS}`} />
                </ActionBar>
            </FPageHeader>
            <FPageContent>
                <DataGroupEditForm runSubmit={runSubmit} onAccessErrorChange={setHasAccessError} />
            </FPageContent>
        </FPage>
    );
};
